module.exports = __webpack_public_path__ + "src/assets/images/index_icon4.png";